import React from 'react';
import PropTypes from 'prop-types';
import {
  TASK_MODEL_SUBJECTS_IDS,
  DRAWING_SUBJECTS,
} from 'chameleon-src/constants/subjects';
import { withRouter } from 'react-router';

const SubunitsListNumberDisplay = ({ unitNumber, displayNumber, params }) => {
  const { subject: subjectId } = params;
  let text = '';
  const subjectIdParsed = parseInt(subjectId, 10);
  // special handling for unit and subunit number display
  if (TASK_MODEL_SUBJECTS_IDS.includes(subjectIdParsed)) {
    text = unitNumber;
  } else if (DRAWING_SUBJECTS.includes(subjectIdParsed)) {
    text = displayNumber;
  } else {
    text = `${unitNumber}.${displayNumber}`;
  }
  return <div className="font-normal text-default text-black">{text}</div>;
};

SubunitsListNumberDisplay.displayName = 'SubunitsListNumberDisplay';

SubunitsListNumberDisplay.propTypes = {
  unitNumber: PropTypes.string.isRequired,
  displayNumber: PropTypes.string,
};

SubunitsListNumberDisplay.defaultProps = {
  displayNumber: '',
};

export default withRouter(SubunitsListNumberDisplay);
